module.exports = __webpack_public_path__ + "assets/img/screen_bg.47700dcc.jpg";